import constants from './src/consts';
import replaceVariables from './src/components/replace-variables';
import InsightBuilderRenderer from './src/components/InsightBuilderRenderer.vue';

export default {
  InsightBuilderRenderer,
  SectionNames: constants.SectionNames,
  getRequiredVariables: replaceVariables.getRequiredVariables,
};
